import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfigurationFacade } from '../../facades/configuration.facade';

@Component({
  selector: 'app-modal-sap',
  templateUrl: './modal-sap.component.html',
  styleUrls: ['./modal-sap.component.scss'],
  standalone: false,
})
export class ModalSapComponent implements OnInit, OnDestroy {

  isSapP40Enable: boolean = false;
  isSapModal: boolean = false;

  private readonly unsubscribe$: Subject<void> = new Subject<void>();
  private readonly configurationFacade: ConfigurationFacade = inject(ConfigurationFacade);

  ngOnInit(): void {
    this._checkModalVisibility();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  hideNotification(): void {
    this.isSapModal = false;
  }

  /**
   * Checks whether the SAP modal should be visible based on configuration settings.
   * @private
   */
  private _checkModalVisibility(): void {
    this.configurationFacade.getSapStatus().subscribe(({ sapIntegration, sapIntegrationRequired }) => {
      this.isSapModal = !sapIntegration && sapIntegrationRequired;
    });
  }
}
